module.exports = __webpack_public_path__ + "media/images/icons/outlined/unordered-list-862ae69cd1119806cafe2edce6f54daf.svg";